import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import ZoomInIcon from '@heroicons/react/outline/ZoomInIcon';
import ZoomOutIcon from '@heroicons/react/outline/ZoomOutIcon';
import Cropper from 'react-easy-crop';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Modal } from '@tribeplatform/react-ui-kit/Modal';
import { Slider } from '@tribeplatform/react-ui-kit/Slider';
import { toast } from '@tribeplatform/react-ui-kit/Toast';
import { logger } from '../common/lib/logger';
import { T, useI18n } from '../i18n';
import { getCroppedImg } from './canvas.utils';
export const CropImageModal = ({ initialImage, onSubmit, open, close, options, }) => {
    var _a;
    const { shape, aspectRatio = 1, restrictPosition = true, minZoom = 1, maxZoom = 3.0, } = options !== null && options !== void 0 ? options : {};
    const { $t } = useI18n();
    const imageSrc = useMemo(() => URL.createObjectURL(initialImage), [initialImage]);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [mediaSize, setMediaSize] = useState(null);
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);
    const onZoomChange = useCallback(newZoom => setZoom(Math.round(10 * newZoom) / 10), []);
    const onApply = async () => {
        setProcessing(true);
        try {
            const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
            onSubmit({ croppedImage, zoom, crop });
        }
        catch (error) {
            logger.error(error);
            toast({
                title: $t({
                    id: 'Generics.SomethingWentWrong',
                    defaultMessage: 'Something went wrong',
                }),
                description: $t({
                    defaultMessage: 'We could not crop this image. Please try another one',
                    id: 'CropImage.FailedToProcess.Description',
                }),
                status: 'error',
            });
            setProcessing(false);
        }
    };
    if (!initialImage || typeof window === 'undefined') {
        return null;
    }
    return (_jsxs(Modal, { open: open, onClose: close, children: [_jsx(Modal.Header, { title: _jsx(T, { id: "CropImageModal.CropImageModal.HeaderTitle", defaultMessage: "Edit image" }, void 0) }, void 0), _jsx(Modal.Content, { children: _jsxs("div", { className: "space-y-3", children: [_jsx("div", { className: "relative", style: { height: (_a = mediaSize === null || mediaSize === void 0 ? void 0 : mediaSize.height) !== null && _a !== void 0 ? _a : 400 }, children: _jsx(Cropper, { image: imageSrc, crop: crop, zoom: zoom, aspect: aspectRatio, onCropChange: setCrop, onCropComplete: onCropComplete, minZoom: minZoom, maxZoom: maxZoom, onZoomChange: onZoomChange, cropShape: shape, restrictPosition: restrictPosition, onMediaLoaded: setMediaSize }, void 0) }, void 0), _jsxs("div", { className: "flex items-center gap-4", children: [_jsx(ZoomOutIcon, { className: "w-6 h-6" }, void 0), _jsx(Slider, { value: zoom, onChange: setZoom, min: minZoom, max: maxZoom, step: 0.01, "aria-labelledby": "Zoom" }, void 0), _jsx(ZoomInIcon, { className: "w-6 h-6" }, void 0)] }, void 0)] }, void 0) }, void 0), _jsxs(Modal.Actions, { children: [_jsx(Button, { onClick: onApply, variant: "primary", loading: processing, children: _jsx(T, { id: "Generics.Apply", defaultMessage: "Apply" }, void 0) }, void 0), _jsx(Button, { variant: "outline", onClick: close, disabled: processing, children: _jsx(T, { id: "Generics.Cancel", defaultMessage: "Cancel" }, void 0) }, void 0)] }, void 0)] }, void 0));
};
//# sourceMappingURL=CropImageModal.js.map